<template>
  <div id="reputation">
    <h3>Reputation</h3>
    <div class="backdrop" v-if="loading">
      <moon-loader :loading="loading" size="21px" color="#007bff" />
    </div>

    <div class="row">
      <div class="outer-box">
        <h4>Delete Review Requests</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Request Id"
            v-model="requestId"
          />
          <div class="center">
            <p v-if="error" class="error">

            </p>

            <p>Add <b>?debug=true</b> end of the url to get the request id</p>

            <button
              class="btn btn-primary unsub-btn"
              @click="deleteReviewRequest()"
              :disabled="loading || requestId.trim() == ''"
            >
              <span>Delete Review Request</span>
            </button>
            <p>
              {{ requestDeleteStatus }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="outer-box">
        <h4>Clear Review Replies</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Review Id"
            v-model="reviewId"
          />
          <div class="center">
            <p v-if="error" class="error">

            </p>

            <p>Add <b>?debug=true</b> end of the url to get the review id</p>
            <p>After clearing disconnect and reconnect the page to sync with google</p>

            <button
              class="btn btn-primary unsub-btn"
              @click="deleteReviewReplies()"
              :disabled="loading || reviewId.trim() == ''"
            >
              <span>Clear Review Replies</span>
            </button>
            <p>
              {{ reviewReplyDeleteStatus }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment";
import { IntegrationsService } from '@/services';

export default {
  data: function () {
    return {
      moment,
      loading: false,
      requestId: "",
      error: null,
      requestDeleteStatus: null,
      reviewId: "",
      reviewReplyDeleteStatus:'',
    };
  },
  components: {},
  methods: {
    async deleteReviewRequest() {
      this.loading = true;
      this.requestDeleteStatus = null;
      try {
        await IntegrationsService.deleteReviewRequest(this.requestId)
        this.requestDeleteStatus = "Review Request Deleted";
      }catch (e) {
        let message = ""
        if(e && e.response && e.response.data && e.response.data.message) {
          message = e.response.data.message
        }
        this.requestDeleteStatus = message || 'Unable to delete Review Request';
      }finally{
        this.loading = false
      }
    },
    async deleteReviewReplies() {
      this.loading = true;
      this.requestDeleteStatus = null;
      try {
        await IntegrationsService.deleteReviewReplies(this.reviewId)
        this.reviewReplyDeleteStatus = "Review replies Deleted";
      }catch (e) {
        let message = ""
        if (e && e.response && e.response.data && e.response.data.message) {
          message = e.response.data.message
        }
        this.reviewReplyDeleteStatus =  message || "Unable to delete Review Replies";
      }finally{
        this.loading = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#reputation {
  position: relative;

  .error {
    color: #e53716;
    font-style: italic;
  }
  .warn {
    color: #ffc107;
  }
  .success {
    color: #28a745;
    font-style: italic;
    margin: 10px;
  }

  .backdrop {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffffa1;
    z-index: 100;
    display: grid;
    justify-content: center;
    align-items: center;
  }
  .free-space {
    margin: 10px 0;
  }
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
